module.exports = __webpack_public_path__ + "static/BryanChadderton-11f9aa329d189c7bbb3ca9721e87bf72.jpg";